import {
  FetchOffersQuery,
  FetchOffersQueryVariables,
} from "graphql/queries/__generated__/offers";

import { fetchOffers } from "../graphql/queries/offers";
import { useQuery } from "@apollo/client";

export const useOffers = (variables?: FetchOffersQueryVariables) => {
  const { data, loading, refetch, error, fetchMore, networkStatus } = useQuery<
    FetchOffersQuery,
    FetchOffersQueryVariables
  >(fetchOffers, {
    variables,
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
  });

  const refresh = () => refetch();

  return {
    offers: data?.fetchOffers?.data || [],
    total_offers: data?.fetchOffers?.total ?? 0,
    from: data?.fetchOffers?.from,
    to: data?.fetchOffers?.to,
    last_page: data?.fetchOffers?.last_page ?? 1,
    total_shares: JSON.parse("{}"),
    loading,
    fetchMore,
    networkStatus,
    error,
    refresh,
  };
};
